const headerData = [{
		prop: "id",
		label: "序号",
		columnwidth: 50,
	},
	{
		prop: "InvCode",
		label: "产品编码",
		columnwidth: 120,
	},
	{
		prop: "InvAddCode",
		label: "产品代码",
		columnwidth: 230,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 80,
	},
	{
		prop: 'HospitalName',
		label: '仓库',
		columnwidth: 70
	},
	{
		prop: "WHCode",
		label: "仓库编码",
		columnwidth: 80,
	},
	{
		prop: "WHName",
		label: "仓库名称",
		columnwidth: 250,
	},
	{
		prop: "Batch",
		label: "批号",
		columnwidth: 160,
	},
	{
		prop: "InvUniqueCode",
		label: "唯一码",
		columnwidth: 148,
	},
	{
		prop: "Quantity",
		label: "数量",
		columnwidth: 50,
	},
	{
		prop: "ValiDate",
		label: "有效期至",
		columnwidth: 100,
	},
	{
		prop: "ManuDate",
		label: "生产日期",
		columnwidth: 100,
	}
]
export default headerData